import { render, staticRenderFns } from "./DialogChapter.vue?vue&type=template&id=233bca6e"
import script from "./DialogChapter.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogChapter.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports